import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { faMinus } from '@fortawesome/pro-light-svg-icons/faMinus';
import { faDash } from '@fortawesome/pro-light-svg-icons/faDash';
import { TypedMemo } from '../../../common/types';

interface ValueChangeElementProps {
  currentValue: number;
}

const ValueChangeElementComponent: React.FC<ValueChangeElementProps> = ({ currentValue }) => {
  const getValueInfo = () => {
    if (currentValue > 0) {
      return {
        icon: faPlus,
        className: 'change-positive',
        value: currentValue,
      };
    }

    if (currentValue < 0) {
      return {
        icon: faMinus,
        className: 'change-negative',
        value: Math.abs(currentValue),
      };
    }

    return {
      icon: faDash,
      className: 'change-neutral',
      value: currentValue,
    };
  };

  const valueInfo = getValueInfo();

  return (
    <div
      className={`${valueInfo.className} d-flex align-items-center justify-content-center rounded px-2 py-1 gap-1 font-monospace`}
      style={{ minWidth: 36 }}
    >
      <FontAwesomeIcon icon={valueInfo.icon} size="sm" />
      {valueInfo.value !== 0 && <span>{valueInfo.value.toLocaleString()}</span>}
    </div>
  );
};

export const ValueChangeElement = TypedMemo(ValueChangeElementComponent);
